import Skeleton from "@mui/material/Skeleton";


const FormPreloader = () => (
    <div className="container">
        <div className="row">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26].map(() => {
                return (
                    <div className="col-md-6">
                        <Skeleton animation="wave" sx={{height: "60px"}}/>
                    </div>
                );
            })}
        </div>
    </div>
);

export default FormPreloader;